var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.connected)?_c('div',{staticClass:"account"},[_c('h1',[_vm._v("Informations personnelles")]),_c('EditInformations',{attrs:{"id":"editInformations"}}),_c('EditPassword',{attrs:{"id":"editPassword"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }